import { createRoot } from "react-dom/client";
import { App } from './App';

let root = createRoot(document.getElementById('root'));
root.render(<App />);

